import _ from 'lodash';
import { POSTCODE_API_URL } from '../constants';

const enrollFormElement = document.querySelector<HTMLFormElement>(
  'form#form_inschrijven',
);
const postalCodeInputElement =
  enrollFormElement?.querySelector<HTMLInputElement>(
    '.form-field.postal-code input',
  );
const houseNumberInputElement =
  enrollFormElement?.querySelector<HTMLInputElement>(
    '.form-field.house-number input',
  );
const streetInputElement = enrollFormElement?.querySelector<HTMLInputElement>(
  '.form-field.street input',
);
const placeInputElement = enrollFormElement?.querySelector<HTMLInputElement>(
  '.form-field.place input',
);

(() => {
  if (!import.meta.env.VITE_POSTCODE_API_TOKEN) {
    // eslint-disable-next-line no-console
    console.warn('No "VITE_POSTCODE_API_TOKEN" environment variable set.');
    return;
  }

  if (
    !enrollFormElement ||
    !postalCodeInputElement ||
    !houseNumberInputElement ||
    !streetInputElement ||
    !placeInputElement
  ) {
    return;
  }

  const disableStreetAndPlaceInputs = (disable = true) => {
    [streetInputElement, placeInputElement].forEach((inputElement) => {
      inputElement.disabled = disable;
    });
  };

  const addressDataListener = async () => {
    try {
      disableStreetAndPlaceInputs();

      const response = await fetch(
        `${POSTCODE_API_URL}/postcode?${new URLSearchParams({
          postcode: postalCodeInputElement.value,
          number: houseNumberInputElement.value,
        })}`,
        {
          headers: {
            Authorization: `Bearer ${import.meta.env.VITE_POSTCODE_API_TOKEN}`,
          },
        },
      );

      const { street, city } = await response.json();
      if (!street || !city) throw new Error();

      streetInputElement.value = street;
      placeInputElement.value = city;

      disableStreetAndPlaceInputs(false);
    } catch (error) {
      disableStreetAndPlaceInputs(false);
      // eslint-disable-next-line no-console
      console.warn('An error occurred while trying to autocomplete address.');
    }
  };

  [postalCodeInputElement, houseNumberInputElement].forEach((inputElement) =>
    inputElement.addEventListener(
      'input',
      _.debounce(addressDataListener, 500),
    ),
  );
})();
